import { defaultFormValues, FormValues } from "./FormValues";
import { PaymentPreference } from "../enums/PaymentPreference";
import { DateTime } from "luxon";
import { Party } from "../enums/Party";
import { BankAccountType } from "../enums/BankAccountType";
import { TreatingPhysician } from "../domain/TreatingPhysician";

export type EmployeeFormValues = FormValues & {
    middleName: string,
    privacyId: string,
    socialSecurityNumber: string,
    dateOfBirth: string,
    emailAddress: string,
    phoneNumber: string,
    streetAddress: string,
    city: string,
    state: string,
    zipCode: string,
    policyNumber: string,
    employerName: string,
    employerZipCode: string,
    employerEmailAddress: string,
    patientFirstName: string,
    patientLastName: string,
    patientDateOfBirth: string,
    treatingPhysicians: TreatingPhysician[],
    paymentPreference: PaymentPreference,
    accountNumber: string,
    accountNumber2: string,
    routingNumber: string,
    accountType: BankAccountType,
    eftConsent: boolean,
    signature: string,
    signatureDate: string
}

export const defaultEmployeeFormValues = {
    ...defaultFormValues,
    party: Party.EMPLOYEE,
    middleName: '',
    privacyId: '',
    socialSecurityNumber: '',
    dateOfBirth: '',
    emailAddress: '',
    phoneNumber: '',
    streetAddress: '',
    city: '',
    state: '',
    zipCode: '',
    policyNumber: '',
    employerName: '',
    employerZipCode: '',
    employerEmailAddress: '',
    patientFirstName: '',
    patientLastName: '',
    patientDateOfBirth: '',
    treatingPhysicians: [{
        physicianFirstName: '',
        physicianLastName: '',
        physicianPhoneNumber: '',
    }],
    paymentPreference: PaymentPreference.EFT,
    accountNumber: '',
    accountNumber2: '',
    routingNumber: '',
    accountType: '',
    eftConsent: false,
    signature: '',
    signatureDate: DateTime.now().toFormat('MM/dd/yyyy')
}
